import { useState, useEffect } from 'react';

export function useAwards() {
  const [awardedBuildings, setAwardedBuildings] = useState<number[]>([]);

  // Load awards from localStorage
  useEffect(() => {
    const saved = localStorage.getItem('supertalls-progress');
    if (saved) {
      try {
        const data = JSON.parse(saved);
        setAwardedBuildings(data.awarded || []);
      } catch (error) {
        console.error('Failed to load awards:', error);
      }
    }
  }, []);

  const isAwarded = (rank: number) => awardedBuildings.includes(rank);

  return {
    awardedBuildings,
    isAwarded
  };
}